<script>
import { mapState, mapMutations } from "vuex";
import { get } from "lodash";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faFirstAid } from "@fortawesome/free-solid-svg-icons";

import config from "@/config/config";

library.add(faFirstAid);

export default {
  name: "ComponentsCourseLecturesMenu",
  computed: {
    ...mapState(config.app, ["course", "currentLectureIndex"]),
    lectures() {
      return get(this, "course.lectures", []);
    },
  },
  methods: {
    ...mapMutations(config.app, ["setCurrentCourse", "setCurrentLectureIndex"]),
    setLecture(index) {
      this.setCurrentCourse(config.initial.course.video);
      this.setCurrentLectureIndex(index);
      this.$parent.changeVideo();
    },
  },
};
</script>
<template>
  <ul id="course-lectures-menu" class="d-flex justify-content-between mb-5">
    <li v-for="(lecture, index) in lectures" :key="lecture.id">
      <a
        @click="setLecture(index)"
        :class="{ active: currentLectureIndex === index }"
      >
        {{ lecture.name }}
      </a>
    </li>
  </ul>
</template>
